module.exports = __webpack_public_path__ + "img/me.9346447a.png";